"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const outline_1 = require("@heroicons/react/24/outline");
const calendar_1 = require("primereact/calendar");
const react_1 = require("react");
const InputDate = (props) => {
    const [date, setDate] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (props.value) {
            const updateDate = new Date();
            updateDate.setDate(props.value[0]);
            updateDate.setMonth(props.value[1]);
            updateDate.setFullYear(props.value[2]);
            setDate(updateDate);
        }
    }, [props.value]);
    const handleChange = (0, react_1.useCallback)((event) => {
        if (props.onChange && event.value !== null && event.value !== undefined) {
            const changeDate = new Date(event.value);
            props.onChange([changeDate.getDate(), changeDate.getMonth(), changeDate.getFullYear()]);
            setDate(event.value);
        }
        else if (props.onChange) {
            props.onChange(null);
            setDate(null);
        }
    }, [props.onChange]);
    return ((0, jsx_runtime_1.jsx)(calendar_1.Calendar, { showIcon: true, className: 'w-full calendar-xs', icon: (0, jsx_runtime_1.jsx)(outline_1.CalendarIcon, { className: 'icon-12px' }), placeholder: props.placeholder, value: date, onChange: handleChange, minDate: props.minDate, maxDate: props.maxDate, invalid: props.invalid }));
};
exports.InputDate = InputDate;
